import React from 'react'
import AuthProvider from 'modules/Auth/AuthProvider'
import AppRouter from 'modules/Auth/AppRouter'
import Reducer from 'modules/Auth/store/reducer'
import Sagas from 'modules/Auth/store/saga'

const Auth = () => (
  <AuthProvider>
    <AppRouter />
  </AuthProvider>
)

export default Auth

export { AuthProvider, AppRouter, Sagas, Reducer }
export { useAuthState } from 'modules/Auth/hooks/useAuthState'
